import { vipStore } from './vip.store';
import { summerStore } from './summer.store';
import { halloweenStore } from './halloween.store';
import { xmasStore } from './xmas.store';

export const GlobalStore = {
  VIP_STORE: vipStore,
  SUMMER_STORE: summerStore,
  HALLOWEEN_STORE: halloweenStore,
  XMAS_STORE: xmasStore,
};

export enum GlobalStoreName {
  VIP_STORE = 'VIP_STORE',
  SUMMER_STORE = 'SUMMER_STORE',
  HALLOWEEN_STORE = 'HALLOWEEN_STORE',
  XMAS_STORE = 'XMAS_STORE'
}
